import { takeEvery, put, select } from 'redux-saga/effects';
import * as TechnicianActions from './technicianActions';
import { makeApiCall, getTechnicianInfo, getKeycloak } from '../helpers';
import technicianServices from './../../services/technicianServices';

export const watchTechnicianRequests = function*() {
    yield takeEvery(TechnicianActions.REQUEST_TECHNICIANS, fetchTechsAsync);
}

const fetchTechsAsync = function* () {
    try {
        const keycloakID = yield select(getKeycloak);
        const technicianInfo = yield select(getTechnicianInfo);
        const technicianData = yield makeApiCall(technicianServices.getTechnicians, technicianInfo.vendorNumber, keycloakID?.userInfo?.sub ?? "");
        yield put(TechnicianActions.requestTechniciansSucceeded(technicianData));

    } catch(responseError) {
        yield put(TechnicianActions.requestTechniciansFailed())
    }
}
